import { ClassProvider } from '@angular/core'
import { HTTP_INTERCEPTORS } from '@angular/common/http'

import { FormFeedbackInterceptor } from '../interceptors/form-feedback.interceptor'

export const FORM_FEEDBACK_INTERCEPTOR: ClassProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: FormFeedbackInterceptor,
  multi: true,
}
